var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUShapeSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 55,
    fill: "none",
    viewBox: "0 0 43 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M8.966 41.397V3.056a3.056 3.056 0 1 1 6.111 0v32.448a4 4 0 0 0 4 4h5.314a4 4 0 0 0 4-4V2.946a2.946 2.946 0 0 1 5.893 0v38.45a4 4 0 0 1-4 4H12.966a4 4 0 0 1-4-4Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.51,
    cy: 3.056,
    r: 3.056,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.74,
    cy: 3.056,
    r: 3.056,
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.51,
    cy: 12.222,
    r: 3.056,
    fill: "#D9D9D9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.74,
    cy: 12.222,
    r: 3.056,
    fill: "#D9D9D9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.51,
    cy: 21.389,
    r: 3.056,
    fill: "#D9D9D9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.74,
    cy: 21.389,
    r: 3.056,
    fill: "#D9D9D9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.51,
    cy: 30.556,
    r: 3.056,
    fill: "#D9D9D9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.74,
    cy: 30.556,
    r: 3.056,
    fill: "#D9D9D9"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.51,
    cy: 39.722,
    r: 3.056,
    fill: "#D9D9D9"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.74,
    cy: 39.722,
    r: 3.056,
    fill: "#D9D9D9"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.24,
    cy: 51.944,
    r: 3.056,
    fill: "#D9D9D9"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.844,
    cy: 51.944,
    r: 3.056,
    fill: "#D9D9D9"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.447,
    cy: 51.944,
    r: 3.056,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUShapeSpace);
export default __webpack_public_path__ + "static/media/u-shape-space.90a2aad0bd9d00683a4f18af62d01133.svg";
export { ForwardRef as ReactComponent };